import { datadogLogs } from "@datadog/browser-logs";

type ErrorPageReport = {
  digest?: string;
  kind: "client_exception" | "error_boundary_fallback";
  pathname: string;
};

function getRouteGroup(pathname: string): string {
  const segments = new Set(pathname.split("/").filter(Boolean));

  if (segments.has("login")) {
    return "login";
  }
  if (segments.has("checkout")) {
    return "checkout";
  }
  if (segments.has("product")) {
    return "product_detail";
  }
  if (segments.has("products")) {
    return "product_listing";
  }
  if (segments.has("dealers")) {
    return "dealers";
  }
  return "other";
}

export function reportErrorPage(report: ErrorPageReport): void {
  const digest = report.digest?.match(/^[a-zA-Z0-9_-]{1,128}$/)?.[0];

  try {
    datadogLogs.logger.error("500 error page displayed", {
      event: "error_page_displayed",
      error_page: {
        code: 500,
        kind: report.kind,
        route_group: getRouteGroup(report.pathname),
        ...(digest ? { digest } : {}),
      },
    });
  } catch {
    // Telemetry must never interrupt error recovery.
  }
}
